<template>
    <!--MODALS START-->
    <div id="modal-choose-client" class="modal">
        <button data-iziModal-close class="icon-close">
            <svg><use xlink:href="#i_close"></use></svg>
            <span class="sr-only">{{ $t('close') }}</span>
        </button>
        <div>
            <h2>{{ $t('chooseExisting') }}</h2>

                <div class="inputWrap">
                    <label for="existingClient">{{ $t('choose') }}</label>
                    <div class="selectWrap">
                        <select name="existingClient" id="existingClient" v-model="selected" onchange="window.onClientSelected()" required>
                            <option value="">{{ $t('select') }}</option>
                            <option v-for="user in this.$store.state.users" v-bind:value="user.id">{{ user.name }}</option>
                        </select>
                        <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                    </div>
                </div>
        </div>
    </div>
    <!--MODALS END-->
</template>

<script>
    export default {
        name: 'ClientSelectorModal',
        data() {
            return{
                client:null,
                selected:''
            }
        },

        mounted(){
            let _this = this;
            window.onClientSelected = function(){
                $("#modal-choose-client").iziModal('close');
                _this.$emit('setClient',$("#existingClient").val());
            };
        },

    }

</script>
